import memoize from 'memoize-one';

import type { ExtensionHandlers } from '@atlaskit/editor-common/extensions';
import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';
import type { EditorAppearance } from '@atlaskit/editor-common/types';
import type { ExtensionPluginOptions } from '@atlaskit/editor-plugin-extension';
import type { GetPMNodeHeight } from '@atlaskit/editor-common/extensibility';

import type { ReferentialityPluginOptions } from '@atlassian/editor-referentiality';
import { createReferentiality } from '@atlassian/editor-referentiality';
import type { ReferentialityContext } from '@atlassian/editor-referentiality/types';

import { getEditorAnalyticsAPI } from '@confluence/editor-features/entry-points/getEditorAnalyticsAPI';

import { getConnectDataListener } from './connectDataListener';

export const getReferentialityContext = memoize(
	(
		createAnalyticsEvent: CreateUIAnalyticsEvent,
		contentId: string,
		appearance: EditorAppearance = 'full-page',
		extensionHandlers?: ExtensionHandlers,
		__rendererExtensionOptions?: ExtensionPluginOptions['__rendererExtensionOptions'],
		getExtensionHeight?: GetPMNodeHeight,
	): ReferentialityContext => {
		const editorAnalyticsAPI = getEditorAnalyticsAPI(contentId, createAnalyticsEvent);

		const options: ReferentialityPluginOptions = {
			editorAnalyticsAPI,
			appearance,
			featureFlags: {
				confluence_frontend_macro_interaction_design: true,
			},
			externalObservers: [getConnectDataListener()],
			extensionHandlers,
			__rendererExtensionOptions,
			getExtensionHeight,
		};

		return { ...createReferentiality(options), options };
	},
);
